import { getApiClient } from "./authApiClient";

const client = () => getApiClient("tenant");
const unwrap = (response) => response?.data?.data ?? response?.data;

export async function listAgreementTemplates() {
  return unwrap(await client().get("/internal-documents/templates"));
}

export async function listTenantDocuments(tenantId) {
  return unwrap(await client().get(`/internal-documents/tenants/${encodeURIComponent(tenantId)}`));
}

async function upload(path, file, metadata) {
  const params = new URLSearchParams({
    filename: file.name,
    mimeType: file.type || "application/octet-stream",
    title: metadata.title || file.name,
    category: metadata.category || "other",
  });
  return unwrap(await client().post(`${path}?${params.toString()}`, file, {
    headers: { "Content-Type": "application/octet-stream" },
  }));
}

export const uploadAgreementTemplate = (file, metadata) =>
  upload("/internal-documents/templates/upload", file, metadata);

export const uploadTenantDocument = (tenantId, file, metadata) =>
  upload(`/internal-documents/tenants/${encodeURIComponent(tenantId)}/upload`, file, metadata);

export async function downloadInternalDocument(documentId) {
  const response = await client().get(`/internal-documents/${encodeURIComponent(documentId)}/download`, {
    responseType: "blob",
  });
  return response.data;
}

export async function deleteInternalDocument(documentId) {
  return unwrap(await client().delete(`/internal-documents/${encodeURIComponent(documentId)}`));
}
